import ShCustomValueMapper from '@/components/Helpers/ShCustomValueMapper';

// @vue/component
export default {
  name: 'UserRoleMap',

  components: { ShCustomValueMapper },

  props: {
    role: {
      type: String,
      default: null,
    },
  },
};
